const second = 1 * 1000
const minute = 60 * second
const hour = 60 * minute
const day = 24 * hour

const conferenceConfig = {
  // CONFERENCE DATES
  preEventStartTimestamp: '2025-02-26T07:00:00.000Z',
  startTimestamp: 1741215600000, // Wed Mar 5 2025 16:00:00 GMT-0700 (Mountain Standard Time)
  endTimestamp: 1741395600000, // Sat Mar 7 2025 18:00:00 GMT-0700 (Mountain Standard Time)
  year: '2026',

  cfcSubmissionDeadlineTimestamp: 1751349599000, // Monday, June 30, 2025 11:59:59 PM GMT-06:00 DST
  cfcApprovalDeadlineTimestamp: 1756101599000, // Sunday, August 24, 2025 11:59:59 PM GMT-06:00 DST

  // REGISTRATION PRICING
  earlyBirdStartTimestamp: '2025-09-24T07:00:00.000Z',
  earlyBirdEndTimestamp: '2025-11-01T07:00:00.000Z',
  blackFridayStartTimestamp: '2025-11-24T07:00:00.000Z',
  blackFridayEndTimestamp: '2025-12-01T07:00:00.000Z',
  lastChanceStartTimestamp: '2026-02-16T15:00:00.000Z',
  lastChanceEndTimestamp: '2026-03-05T13:59:00.000Z',

  enableSponsorsDashboardTimestamp: '2025-09-01T06:00:00.000Z',
  exhibitorDeadlineTimestamp: 1771484399000, // Wed Feb 18 2026 23:59:59 GMT-0700 (Mountain Standard Time)
  sponsorDeadlineTimestamp: 1771484399000, // Wed Feb 18 2026 23:59:59 GMT-0700 (Mountain Standard Time)

  playerTimeFrame: 42 * day,

  // PROMOTIONS
  promotionsStartTimestamp: '2026-02-25T07:00:00.000Z',
  promotionsEndTimestamp: '2026-04-14T07:00:00.000Z',

  // CALL FOR PRESENTATIONS
  cfpEndTimestamp: '2026-02-25T07:00:00.000Z',
}

export { second, minute, hour, day, conferenceConfig }
